/**
 * NOTE: This module is used in student header.
 */

import * as React from 'react';

import CloseX from 'CloseX';
import HeaderMenuBars from 'HeaderMenuBars';

export default class HeaderMenuButton extends React.Component {
  render() {
    let c = this.props.controller;
    let m = this.props.model;
    let children = [];

    if (m.mobileMenuVisible) {
      children.push(<CloseX key="1" className="header-menu-close" />);
    } else {
      children.push(<HeaderMenuBars key="2" className="header-menu-bars" />);

      if (this.props.handraiseStatus && this.props.handraise) {
        children.push(<span key="3" className="hand-raised-mobile" />);
      }
    }

    return (
      <div
        className="header-menu-button"
        onClick={(event) => {
          if (c.mobileMenuClicked) {
            c.mobileMenuClicked(event);
          }
        }}
      >
        {children}
      </div>
    );
  }
}
